import { Button, Input, Modal, Typography } from "antd";
import { WarningOutlined } from "@ant-design/icons";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { startSetQuejaPotencial } from "../../../../context/actions/incidenciasActions";
import { emailsPuedeDeclararQueja } from "../../../../constants/cons";
import "./BotonQuejaPotencial.css";

const { Text, Title } = Typography;

export const BotonQuejaPotencial = () => {
  const { asistenciaID } = useParams();
  const dispatch = useDispatch();
  const { quejaPotencial } = useSelector(
    (state) => state.detalleReducer.asistencia
  );
  const [visible, setVisible] = useState(false);
  const [motivo, setMotivo] = useState("");
  const [loading, setLoading] = useState(false);
  const { email } = useSelector((state) => state.userReducer.user);

  const handleOk = async () => {
    setLoading(true);
    const success = await dispatch(
      startSetQuejaPotencial({ asistenciaID, motivo })
    );
    setLoading(false);

    if (success) {
      setVisible(false);
      setMotivo("");
    }
  };

  if (!emailsPuedeDeclararQueja.includes(email?.toLowerCase())) return <></>;

  return (
    <>
      <Button
        onClick={() => setVisible(true)}
        type="dashed"
        danger
        icon={<WarningOutlined />}
      >
        {quejaPotencial ? "Quitar Queja Declarada" : "Establecer Queja Declarada"}
      </Button>

      <Modal
        title={(
          <>
            <WarningOutlined className="queja-potencial-modal__title-icon" />
            Queja Declarada
          </>
        )}
        open={visible}
        wrapClassName="queja-potencial-modal"
        onCancel={() => setVisible(false)}
        onOk={handleOk}
        okText={quejaPotencial ? "Quitar" : "Guardar"}
        cancelText="Cancelar"
        confirmLoading={loading}
        okButtonProps={{ disabled: !quejaPotencial && !motivo.trim() }}
        destroyOnClose
      >
        <div className="queja-potencial-modal__intro">
          <Title level={3} className="queja-potencial-modal__heading">
            {quejaPotencial ? "Quitar marca" : "Registrar motivo"}
          </Title>
          <Text type="secondary" className="queja-potencial-modal__description">
            {quejaPotencial
              ? "La asistencia dejará de estar marcada como queja declarada."
              : "Describe por qué esta asistencia debe marcarse como queja declarada."}
          </Text>
        </div>
        {quejaPotencial ? (
          <div className="queja-potencial-modal__confirmation">
            ¿Deseas continuar con esta acción?
          </div>
        ) : (
          <Input.TextArea
            className="queja-potencial-modal__input"
            value={motivo}
            onChange={({ target }) => setMotivo(target.value)}
            placeholder="Motivo"
            rows={4}
          />
        )}
      </Modal>
    </>
  );
};
